import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class PrintService {
    public printElement(printElement: HTMLElement): void {
        // Tarkistetaan, että elementti on olemassa
        if (!printElement) {
            console.error("Can't find the element to print.");
            return;
        }

        const isDesktop = window.matchMedia('(pointer: fine)').matches;

        // Avataan uusi ikkuna tulostusta varten
        const printWindow = window.open(
            '',
            '_blank',
            'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0'
        );
        if (!printWindow) {
            console.error("Can't open print window.");
            return;
        }

        // Haetaan styles.*.css -tiedoston oikea href-osoite
        const styleLink = Array.from(document.querySelectorAll('link[rel="stylesheet"]'))
            .find((el): el is HTMLLinkElement => el instanceof HTMLLinkElement && el.href.includes('styles'));

        const styleHref = styleLink?.href ?? '';

        // Luodaan uusi HTML-rakenne tulostusikkunaan
        const htmlContent = `
      <!DOCTYPE html>
      <html>
        <head>
          <meta charset="utf-8">
          <title>Tulostus Esikatselu</title>
          ${styleHref ? `<link rel="stylesheet" href="${styleHref}">` : ''}
          
          <style>
            @font-face {
              font-family: "Titillium Web";
              src: url("http://localhost:4200/titillium-web-latin-700.woff2") format("woff2");
              font-weight: 700;
              font-style: normal;
              font-display: swap;   // teksti näkyy heti varafontilla
            }
            @font-face {
              font-family: "Titillium Web";
              src: url("http://localhost:4200/titillium-web-latin-400.woff2") format("woff2");
              font-weight: 400;
              font-style: normal;
              font-display: swap;
            }
            @font-face {
              font-family: "Titillium Web";
              src: url("http://localhost:4200/titillium-web-latin-600.woff2") format("woff2");
              font-weight: 600;
              font-style: normal;
              font-display: swap;
            }
            @font-face {
              font-family: "Titillium Web";
              src: url("http://localhost:4200/titillium-web-latin-200.woff2") format("woff2");
              font-weight: 200;
              font-style: normal;
              font-display: swap;
            }
          
             
            /* Tulostustyylit */
            @media print {
              @page {
                margin: 0;
                size: A4 portrait;
              }
              html, body, app-root {
                margin: 0;
                padding: 0;
                font-family: Titillium Web, sans-serif;
                -webkit-print-color-adjust: exact;
                color-adjust: exact;
              }
            }
            /* Näyttötyylit */
            body {
              font-family: Titillium Web, sans-serif;
              margin: 20px;
            }
          </style>
        </head>
        <body>
          ${printElement.innerHTML}
        </body>
      </html>
    `;

        // Kirjoitetaan sisältö uuteen tulostusikkunaan
        printWindow.document.open();
        printWindow.document.write(htmlContent);



        printWindow.document.close();

        // Kun ikkuna on ladannut sisällön, käynnistetään tulostus ja suljetaan ikkuna
        printWindow.onload = () => {
            printWindow.focus();
            printWindow.print();
        };

        printWindow.addEventListener('afterprint', () => {
            if(isDesktop){ //Mobiili toimii eri tavalla ja sulkemsita ei voi kutsua näin. TODO: Tunnista mobiilissa tulostuksen lopetus ja sulje sivu.
                printWindow.close();
            }
        });
    }
}
